/* "Contract added." once, on the contract page Add contract opened.
 *
 * Add contract sends the person to the new contract with ``added: true`` in
 * the page's history entry. This reads it once and takes it out again, so a
 * reload of the page does not announce the contract a second time. Used by
 * the contract page.
 */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function useAddedNotice() {
  const location = useLocation();
  const history = useHistory();
  const [added] = useState(() => Boolean(location.state?.added));

  useEffect(() => {
    if (!location.state?.added) return;
    const { added: _shown, ...rest } = location.state;
    history.replace({ ...location, state: rest });
    // Once, on arrival: later navigation inside the page must not re-run it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return added;
}
